/**
 * PresentationProgramSelectionView React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


import React from 'react';
import {withStyles} from "@material-ui/core";
import PropTypes from 'prop-types';
import {getMediaUrl} from '../../../operations/utils';
import PresentationSlideView from "./PresentationSlideView";
import PresentationTitle from "./PresentationTitle";
import MajusculeText from "./MajusculeText";
import AnimatedUpdate from "../../animation/AnimatedUpdate";
import {getHorizontalAnimate, getStandardTransition} from "./animationUtils";
import {patchServerUrl} from "../../../config";


/**
 * PresentationProgramSelectionView
 *
 * @author Jens Gruschel
 */
function PresentationProgramSelectionView(props) {

    const presentationProgram = props.presentationProgram || {};
    const presentationProgramFields = presentationProgram.fields || {};

    const teaser = "Danke dass du die App heruntergeladen hast. Beginne die Reise indem du eines der Themen auswählst";
    const title = "Beginne die Reise";
    const subheading = "Wähle ein Thema aus\nNutze die Navigation der App";

    const presentationItems = props.findReferencedObjects(presentationProgramFields['items']);

    // note that teaser and title are swapped in this view

    const titleElement = <AnimatedUpdate tag={teaser} order={props.index} animate={getHorizontalAnimate()} transition={getStandardTransition(0.5)}>
        <div className={props.classes.topAlignedTeaser}><MajusculeText text={teaser} /></div>
    </AnimatedUpdate>;

    const teaserElement = <PresentationTitle
        className={props.classes.bottomAlignedTeaser}
        title={title}
        subheading={subheading}
    />;

    const chapterElement = <div className={props.classes.programItemsSection}>
        {presentationItems.map(item => {
            const itemFields = item.fields || {};
            const imageItem = props.findReferencedObjects(itemFields['image']);
            const imageUrl = getMediaUrl(imageItem) || item.imageurl;
            const backgroundStyle = {
                backgroundImage: imageUrl && "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 1) 75%, rgba(0, 0, 0, 1) 100%), url(" + patchServerUrl(imageUrl) + ")",
                backgroundSize: "cover",
                backgroundPosition: "50% 50%",
                backgroundRepeat: "no-repeat",
            };
            return <div key={item.id} className={props.classes.programItemSection} style={backgroundStyle}>
                <PresentationTitle
                    className={props.classes.bottomAlignedItemTitle}
                    title={itemFields.title}
                    subheading={itemFields.subheading}
                />
            </div>;
        })}
    </div>;

    const slideData = {
        titleElement: titleElement,
        teaserTag: "title:" + title + ";subheading:" + subheading,
        teaserElement: teaserElement,
        teaserImageUrl: null,
        chapterTitle: "Projektwahl",
        chapterTag: "programselection:" + presentationProgram.id,
        chapterElement: chapterElement,
        chapterImageUrl: null
    };

    return <PresentationSlideView
        screenIndex={props.screenIndex}
        data={slideData}
    />;
}

PresentationProgramSelectionView.propTypes = {
    screenIndex: PropTypes.number,
    presentationProgram: PropTypes.object,
    findReferencedObjects: PropTypes.func.isRequired
};

const styles = theme => ({
    topAlignedTeaser: {
        position: "absolute",
        top: "0vw",
        left: "8vw",
        width: "84vw"
    },
    bottomAlignedTeaser: {
        position: "absolute",
        bottom: "0vw",
        left: "8vw",
        width: "84vw"
    },
    bottomAlignedItemTitle: {
        position: "absolute",
        bottom: "5vw",
        left: "8vw",
        width: "84vw"
    },
    programItemsSection: {
        width: "100vw",
        marginTop: "8vw"
    },
    programItemSection: {
        position: "relative",
        width: "100vw",
        height: "75vw"
    }
});

export default withStyles(styles)(PresentationProgramSelectionView);
